/* eslint-disable max-len */
import React from 'react'

import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import AnimatedList from '../../../../../../components/Animation/AnimatedList'
import moment from 'moment'
import { convertEpochToDateFormat } from '../../../../../../CommonMethods/DateConversion'

const TableBody=({
    tableData,
    indexNum,
})=>{
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const fieldTOUpdate={
        UserName:'UserName',
        Field:'Field',
        Timestamp:'Timestamp',
        OldValue:'Old Value',
        NewValue:'New Value',
        Action:'Action',
        Comments:'Comments',
    }
    const date=convertEpochToDateFormat(tableData?.timestamp,dateformat)
    
    // const date = dateformat?.includes('AM/PM')?moment(tableData?.timestamp).utcOffset('+5:30').format(`${dateformat.split(',')[0]} h:mm:ss A`):moment(tableData?.created_at).format(dateformat)
    return(
        <>
            <AnimatedList
                id={tableData._id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {tableData?.user_name}
                        </td>

                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {date}
                        </td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize">{tableData?.filter_name  || "-"}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize">{tableData?.table_name==='' ? '-' : tableData?.table_name}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize">
                            {fieldTOUpdate[tableData?.exported_column_name] &&
        typeof fieldTOUpdate[tableData?.exported_column_name] === 'string'
                                ? fieldTOUpdate[tableData?.exported_column_name].replace(/_/g, " ") + '  ,  '
                                : (tableData?.exported_column_name || '').toString().replace(/_/g, " ")}
                        </td>
                    </>
                    
                }/>
           
        </>
    )
}

export default TableBody